import { AddressData } from '@jobilla/nexus-sdk'

type DisplayAddressProps = {
	address: AddressData
}

export function DisplayAddress({ address }: DisplayAddressProps) {
	switch (address.country) {
		case 'DE':
		case 'NL':
			return (
				<>
					{address.line1}
					<br />
					{address.line2
						? (
							<>
								{address.line2}
								<br />
							</>
						)
						: null}
					{address.postalCode ? <>{address.postalCode}</> : null}
					{address.city
						? (
							<>
								<></>
								{address.city}
							</>
						)
						: null}
					{address.state
						? (
							<>
								<></>
								{address.state}
							</>
						)
						: null}
					{address.country
						? (
							<>
								<></>
								{address.country}
							</>
						)
						: null}
				</>
			)
		case 'FI':
			return (
				<>
					{address.line1}
					<br />
					{address.line2
						? (
							<>
								{address.line2}
								<br />
							</>
						)
						: null}
					{address.postalCode ? <>{address.country}-{address.postalCode}</> : null}
					{address.city
						? (
							<>
								<></>
								{address.city}
							</>
						)
						: null}
					{address.state
						? (
							<>
								<></>
								{address.state}
							</>
						)
						: null}
					{address.country
						? (
							<>
								<></>
								{address.country}
							</>
						)
						: null}
				</>
			)
		case 'GB':
		default:
			return (
				<>
					{address.line1}
					{address.line2
						? (
							<>
								<br />
								{address.line2}
							</>
						)
						: null}
					{address.city
						? (
							<>
								<br />
								{address.city}
							</>
						)
						: null}
					{address.postalCode
						? (
							<>
								<br />
								{address.postalCode}
							</>
						)
						: null}
					{address.state
						? (
							<>
								<></>
								<br />
								{address.state}
							</>
						)
						: null}
					{address.country
						? (
							<>
								<></>
								<br />
								{address.country}
							</>
						)
						: null}
				</>
			)
	}
}
